<template>
  <div class="error-block">
    <icon name="warning" />
    <div class="text-small text-left ml-1">
      <slot />
    </div>
  </div>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
  name: 'ErrorBlock',
  components: {
    Icon,
  },
}
</script>

<style lang="scss">
.error-block {
  display: flex;
  align-items: center;
  background: var(--error-background);
  color: var(--tertiary-color);
  padding: var(--spacing);

  .icon {
    width: rem(30px);
    height: rem(26px);
  }

  a {
    color: inherit;
    text-decoration: underline;

    @include on-hover-and-focus {
      text-decoration: none;
    }
  }
}
</style>
